export const getLowestDate = (dates: Date[]) => {
    return dates.slice().sort((a, b) => b.getTime() - a.getTime()).at(0);
}

export const getHighestDate = (dates: Date[]) => {
    return dates.slice().sort((a, b) => b.getTime() - a.getTime()).at(-1);
}

export const getArrayOfUniqueDays = (dates: Date[]) => {
    var sortedDates = dates.slice().sort((a, b) => b.getTime() - a.getTime());
    var lastDay = sortedDates[0].getDay();
    var uniqueDays = [sortedDates[0]];
    for (var i = 1; i < sortedDates.length; i++) {
        if (sortedDates[i].getDay() !== lastDay) {
            uniqueDays.push(sortedDates[i]);
            lastDay = sortedDates[i].getDay();
        }
    }
    return uniqueDays;
}

export const getDaysBetweenDates = (startDate?: Date | string, endDate?: Date | string) => {

    if (!startDate || !endDate) {
        return 0;
    }

    if (typeof startDate === 'string') {
        startDate = new Date(startDate);
    }

    if (typeof endDate === 'string') {
        endDate = new Date(endDate);
    }

    if (isNaN(startDate.getTime()) || isNaN(endDate.getTime())) {
        return 0;
    }

    const timeDifference: number = endDate.getTime() - startDate.getTime();
    const millisecondsInOneDay: number = 24 * 60 * 60 * 1000;
    return timeDifference / millisecondsInOneDay;
}